import { render, staticRenderFns } from "./XvUserOrders.vue?vue&type=template&id=4e6a4cfa&"
import script from "./XvUserOrders.vue?vue&type=script&lang=ts&"
export * from "./XvUserOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports